var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23847 21.6829V8.49171H1.85782V21.6829H6.23893H6.23847ZM4.04906 6.69099C5.57637 6.69099 6.52722 5.67806 6.52722 4.41219C6.49863 3.11747 5.57637 2.13281 4.07811 2.13281C2.57882 2.13281 1.59961 3.11747 1.59961 4.41207C1.59961 5.67795 2.55012 6.69088 4.02036 6.69088H4.04872L4.04906 6.69099ZM8.66323 21.6829H13.0435V14.3171C13.0435 13.9234 13.0721 13.5287 13.1879 13.2474C13.5044 12.4594 14.2252 11.6437 15.4356 11.6437C17.0203 11.6437 17.6546 12.8533 17.6546 14.6267V21.6829H22.0348V14.1195C22.0348 10.0679 19.874 8.18245 16.9919 8.18245C14.6291 8.18245 13.5913 9.5043 13.0147 10.4046H13.0439V8.49217H8.66346C8.72063 9.72966 8.66311 21.6834 8.66311 21.6834L8.66323 21.6829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInDark);
export default __webpack_public_path__ + "static/media/inDark.0bf9118ab3778d57b7f8d2f6faef362a.svg";
export { ForwardRef as ReactComponent };